import { render, staticRenderFns } from "./header-banner.vue?vue&type=template&id=2f767222&scoped=true&"
import script from "./header-banner.vue?vue&type=script&lang=js&"
export * from "./header-banner.vue?vue&type=script&lang=js&"
import style0 from "./header-banner.vue?vue&type=style&index=0&id=2f767222&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f767222",
  null
  
)

export default component.exports